import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { NavMarker } from 'react-rhumb';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Flex } from 'foundations-components/components/Flex';
import SectionHeading from '../../../components/SectionHeading';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import I18n from 'I18n';
import { useAnnouncements } from '../hooks/AnnouncementsSectionHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AnnouncementsSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    announcements,
    error
  } = useAnnouncements();
  if (error) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "HOMEPAGE_ANNOUNCEMENTS_ERROR"
    });
  }
  if (!announcements.length) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "HOMEPAGE_ANNOUNCEMENTS_LOADED"
    });
  }
  const featuredAnnouncement = announcements[0];
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "HOMEPAGE_ANNOUNCEMENTS_LOADED",
    children: /*#__PURE__*/_jsx(CardWrapper, {
      borderRadius: "300",
      "data-test-id": "announcements-section",
      marginBlockEnd: "1100",
      marginBlockStart: "800",
      padding: isMobile ? '600' : '1000',
      paddingBlock: isMobile ? '500' : '1000',
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "900",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsxs(View, {
          maxInlineSize: isMobile ? '100%' : '50%',
          children: [/*#__PURE__*/_jsx(SectionHeading, {
            marginBlockEnd: "400",
            children: featuredAnnouncement.title
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockEnd: "600",
            typography: "body-200",
            children: featuredAnnouncement.body
          }), featuredAnnouncement.ctaURL && /*#__PURE__*/_jsx(RouterButton, {
            onClick: () => {
              //TO-DO: Add event tracking for CTA
            },
            to: featuredAnnouncement.ctaURL,
            use: "primary",
            children: featuredAnnouncement.ctaText || ''
          })]
        }), !isMobile && /*#__PURE__*/_jsx(View, {
          inlineSize: "250px",
          children: /*#__PURE__*/_jsx(Image, {
            alt: I18n.text('learningCenter.announcements.altText'),
            blockSize: "auto",
            inlineSize: "100%",
            objectFit: "contain",
            src: featuredAnnouncement.imageSrc || ''
          })
        })]
      })
    })
  });
};
export default AnnouncementsSection;